// src/pages/GoogleAuthCallback.js
import React, { useEffect, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Box, CircularProgress, Typography } from '@mui/material';

function GoogleAuthCallback() {
  const { handleGoogleCallback } = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const error = searchParams.get('error');

    if (error) {
      console.error('Google authentication error:', error);
      navigate('/auth', { 
        state: { error: 'Google authentication failed. Please try again.' } 
      });
      return;
    }

    if (token) {
      handleGoogleCallback(token);
      navigate('/list-orgs', { replace: true });
    } else {
      navigate('/auth', { 
        state: { error: 'No authentication token received.' } 
      });
    }
  }, [searchParams, handleGoogleCallback, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography variant="h6">
        Completing Google authentication...
      </Typography>
    </Box>
  );
}

export default GoogleAuthCallback;